<template>
	<div class="layout">
		<div class="div-title">
			<div class="div-title-label">
				基本信息
			</div>
		</div>
		<div class="div-content">
			<div class="div-content-left">
				<ImagePage :imageData='commodityData.imgFile'></ImagePage>
			</div>
			<div class="div-content-right">
				<div class="div-content-right-col">
					<div class="div-content-right-col-cell">
						商品名称：<span class="div-content-right-col-cell-span">{{commodityData.name}}</span>
					</div>
					<div class="div-content-right-col-cell">
						商品规格：<span class="div-content-right-col-cell-span">{{commodityData.format}}</span>
					</div>
					<div class="div-content-right-col-cell">
						所在仓库：<span class="div-content-right-col-cell-span">{{commodityData.depotName}}</span>
					</div>
					<div class="div-content-right-col-cell">
						采购价格：<span class="div-content-right-col-cell-span">{{commodityData.intoPrice}}</span>
					</div>
					<div class="div-content-right-col-cell">
						商品单位：<span class="div-content-right-col-cell-span">{{commodityData.unit}}</span>
					</div>
					<div class="div-content-right-col-cell">
						有效日期：<span class="div-content-right-col-cell-span">{{commodityData.validityPeriod}}</span>
					</div>
					<div class="div-content-right-col-cell">
						备注：<span class="div-content-right-col-cell-span">{{commodityData.note}}</span>
					</div>
				</div>
				<div class="div-content-right-col">
					<div class="div-content-right-col-cell">
						商品种类：<span class="div-content-right-col-cell-span">{{commodityData.type}}</span>
					</div>
					<div class="div-content-right-col-cell">
						商品条码：<span class="div-content-right-col-cell-span">{{commodityData.code}}</span>
					</div>
					<div class="div-content-right-col-cell">
						所在货位：<span class="div-content-right-col-cell-span">{{commodityData.commodityAddressName}}</span>
					</div>
					<div class="div-content-right-col-cell">
						销售价格：<span class="div-content-right-col-cell-span">{{commodityData.outPrice}}</span>
					</div>
					<div class="div-content-right-col-cell">
						库存：<span class="div-content-right-col-cell-span">{{commodityData.stock}}</span>
					</div>
					<div class="div-content-right-col-cell">
						库存预警：<span class="div-content-right-col-cell-span">{{commodityData.stockPrompt}}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="div-title">
			<div class="div-title-label">
				副计量单位
			</div>
		</div>
		<div class="div-content">
			<Table row-key="rowNum" :columns="extraUnitColumns" :data="commodityData.extraUnits"></Table>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import ImagePage from '@/components/ImagePage'
	export default {
		name: 'commoditydetailinfo',
		components: {
			ImagePage
		},
		data() {
			return {
				commodityId: 0,
				commodityData: {
					id: 0,
					code: '',
					name: '',
					imgFile: [],
					type: '',
					unit: '',
					format: '',
					intoPrice: 0,
					outPrice: 0,
					stockPrompt: 0,
					validityPeriod: null,
					commodityAddressId: "",
					depotId: "",
					stock: 0,
					isMultiMetering: false,
					extraUnits: [],
					note: '',
					creator: parseInt(localStorage.getItem("userId")),
					isUse: true
				},
				extraUnitColumns: [{
						title: '行号',
						key: 'rowNum',
						width: 70
					},
					{
						title: '单位',
						key: 'unit',
						width: 150
					},
					{
						title: '换算率',
						key: 'conversionRate'
					},
					{
						title: '换算进价',
						key: 'conversionIntoPrice'
					},
					{
						title: '换算售价',
						key: 'conversionOutPrice'
					},
					{
						title: '换算库存',
						key: 'conversionStock'
					},
					{
						title: '备注',
						key: 'note',
						width: 300
					}
				]
			}
		},
		methods: {
			initCommodityInfo(id) {
				let self = this;
				request.get('/api/Commodity/GetCommodity', {
					params: {
						id: id
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取商品数据失败：" + response.errorMsg
						});
						return;
					}
					self.commodityData = response.data;
				}).catch(function(error) {})
			}
		},
		watch: {
			'$route.query.commodityId':{
				immediate: true,
				handler(param) {
					if(param){
						this.initCommodityInfo(param);
					}
				}
			}
		},
		created: function() {
		}
	}
</script>

<style scoped>
	.layout {
		background: #fff;
		border-radius: 8px;
		padding: 5px 10px;
	}

	.div-title {
		padding: 10px 0px;
		border-bottom: 1px solid #ebeef5;
		margin-top: 20px;
	}

	.div-title-label {
		border-left: 2px solid rgb(255, 106, 127);
		text-indent: 0.5em;
		font-weight: bold;
	}

	.div-content {
		overflow: hidden;
		padding-top: 20px;
		margin-bottom: 20px;
	}

	.div-content-left {
		float: left;
		width: 30%;
	}

	.div-content-left-image {
		margin-top: 20px;
	}

	.div-content-left-image img {
		width: 300px;
		height: 300px;
	}

	.div-content-left-image-index {
		overflow: hidden;
		width: 300px;
	}

	.div-content-left-image-index-left {
		float: left;
		width: 6%;
		display: flex;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 45px;
		cursor: pointer;
	}

	.div-content-left-image-index-left:hover {
		border: rgb(255, 106, 127) 1px solid;
		color: rgb(255, 106, 127);
	}

	.div-content-left-image-index-center {
		float: left;
		width: 88%;
		overflow-y: auto;
		padding: 0px 4px;
	}

	.div-content-left-image-index-center img {
		width: 44px;
		height: 44px;
		cursor: pointer;
		margin-right: 4px;
	}

	.selected-image {
		border: rgb(255, 106, 127) 1px solid;
	}

	.div-content-left-image-index-right {
		float: right;
		width: 6%;
		display: flex;
		justify-content: center;
		/* 水平居中 */
		align-items: center;
		/* 垂直居中 */
		height: 45px;
		cursor: pointer;
	}

	.div-content-left-image-index-right:hover {
		border: rgb(255, 106, 127) 1px solid;
		color: rgb(255, 106, 127);
	}

	.div-content-right {
		float: left;
		width: 70%;
		overflow: hidden;
	}

	.div-content-right-col {
		float: left;
		width: 50%;
	}

	.div-content-right-col-cell {
		padding: 15px;
	}
	
	.div-content-right-col-cell-span{
		color: black;
	}
</style>